export const LV = {
    translations: {
        notifications: 'Paziņojumi',
        markAllAsRead: 'Atzīmēt visus kā lasītus',
        poweredBy: 'Izstrādāts',
        settings: 'Iestatījumi',
        noNewNotification: 'Šeit vēl nav nekā jauna, ko redzēt',
    },
    lang: 'lv',
};
//# sourceMappingURL=lv.js.map